var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bike-line copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uD83D\\uDCCFCirculation-Rules",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circulation-Rules_MODAL_ZOOM",
    transform: "translate(-895.000000, -269.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bike-line-copy-2",
    transform: "translate(895.000000, 269.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 16 0 16 16 0 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66666667,8 L2.66666667,8 L2.66666667,4.66666667 L2,4.66666667 C1.63181017,4.66666667 1.33333333,4.36818983 1.33333333,4 C1.33333333,3.63181017 1.63181017,3.33333333 2,3.33333333 L4.66666667,3.33333333 C5.0348565,3.33333333 5.33333333,3.63181017 5.33333333,4 C5.33333333,4.36818983 5.0348565,4.66666667 4.66666667,4.66666667 L4,4.66666667 L4,4.66666667 L4,6.53 L10.542,4.77733333 L10.1553333,3.33333333 L8.66666667,3.33333333 C8.29847683,3.33333333 8,3.0348565 8,2.66666667 C8,2.29847683 8.29847683,2 8.66666667,2 L10.652,2 L10.652,2 C10.9591557,1.99322327 11.2311687,2.19723309 11.3106667,2.494 L12.346,6.358 L11.058,6.70266667 L10.8873333,6.06533333 L3.66666667,8 Z M3.33333333,12.6666667 C4.069713,12.6666667 4.66666667,12.069713 4.66666667,11.3333333 C4.66666667,10.5969537 4.069713,10 3.33333333,10 C2.59695367,10 2,10.5969537 2,11.3333333 C2,12.069713 2.59695367,12.6666667 3.33333333,12.6666667 Z M3.33333333,14 C1.860574,14 0.666666667,12.8060927 0.666666667,11.3333333 C0.666666667,9.860574 1.860574,8.66666667 3.33333333,8.66666667 C4.80609267,8.66666667 6,9.860574 6,11.3333333 C6,12.8060927 4.80609267,14 3.33333333,14 Z M12,12.6666667 C13.1045695,12.6666667 14,11.7712362 14,10.6666667 C14,9.56209717 13.1045695,8.66666667 12,8.66666667 C10.8954305,8.66666667 10,9.56209717 10,10.6666667 C10,11.7712362 10.8954305,12.6666667 12,12.6666667 Z M12,14 C10.1590508,14 8.66666667,12.5076158 8.66666667,10.6666667 C8.66666667,8.8257175 10.1590508,7.33333333 12,7.33333333 C13.8409492,7.33333333 15.3333333,8.8257175 15.3333333,10.6666667 C15.3333333,12.5076158 13.8409492,14 12,14 Z",
    id: "Shape",
    fill: "#020078",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/bike.9049078b5e11e8454b9414c043aa17e9.svg";
export { ForwardRef as ReactComponent };